module.exports = __webpack_public_path__ + "static/img/10.9d261d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/1/eng/10.png
// module id = 8gyQ
// module chunks = 0